<template>
  <b-modal
    ref="modalUpdatePassword"
    id="modalUpdatePassword"
    @show="initModal"
    @hidden="hidden"
    @ok="handleOk"
    no-close-on-backdrop
  >
    <template #modal-title>
      {{ title }}
    </template>
    <b-alert v-if="message" show>
      {{ message }}
    </b-alert>
    <b-form ref="formUpdatePassword" @submit.prevent="updatePassword">
      <form-auth
        ref="formAuth"
        :showInput="showInput"
        v-model="value"
      ></form-auth>
      <b-form-group class="mb-3" label="Nouveau mot de passe">
        <b-form-input
          type="password"
          v-model="passwordNew"
          autocomplete="off"
          :state="passwordNewValide"
          ref="passwordNew"
          required
        >
        </b-form-input>
        <b-form-text>
          Le mot de passe doit comporter au minimum :
          <ul>
            <li>
              8 caractères
              <i
                v-if="checkConstrainteLen"
                class="fa fa-check text-success"
                aria-hidden="true"
              ></i>
            </li>
            <li>
              Un chiffre : 0-9
              <i
                v-if="checkConstrainteNumber"
                class="fa fa-check text-success"
                aria-hidden="true"
              ></i>
            </li>
            <li>
              Une majuscule : A-Z
              <i
                v-if="checkConstrainteMajuscule"
                class="fa fa-check text-success"
                aria-hidden="true"
              ></i>
            </li>
            <li>
              Une minuscule : a-z
              <i
                v-if="checkConstrainteMinuscule"
                class="fa fa-check text-success"
                aria-hidden="true"
              ></i>
            </li>
            <li>
              Un caractère spécial : #$%&@^`~*+!?={[()]}
              <i
                v-if="checkConstrainteSpecialChar"
                class="fa fa-check text-success"
                aria-hidden="true"
              ></i>
            </li>
          </ul>
        </b-form-text>
      </b-form-group>
      <b-form-group class="mb-3" label="Confirmez votre nouveau mot de passe">
        <b-form-input
          type="password"
          v-model="passwordNewBis"
          autocomplete="off"
          :state="passwordNewBisValide"
          required
        >
        </b-form-input>
      </b-form-group>
    </b-form>
    <template #modal-footer="{ ok }">
      <b-button @click="hide"> Annuler </b-button>
      <b-button :disabled="!checkFormValidity" variant="success" @click="ok">
        Valider
      </b-button>
    </template>
  </b-modal>
</template>

<script>

import FormAuth from './FormAuth.vue'

export default {
  name: 'modal-update-password',
  data () {
    return {
      title: null,
      message: null,
      showInput: {
        login: false,
        correspondant: false,
        password: true
      },
      passwordNew: null,
      passwordNewBis: null,
      updatePasswordLoad: false
    }
  },
  props: {
    value: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    },
    upgradePassword: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted: function () {
    const vm = this

    if (vm.$route.query.token) {
      vm.show()
    }
  },
  methods: {
    initModal () {
      const vm = this

      vm.title = 'Mise à jour de votre mot de passe'
      vm.message = null

      if (vm.$route.query.token) {
        vm.value.login = vm.$route.query.login
        vm.value.correspondant = vm.$route.query.correspondant
        vm.value.password = vm.$route.query.token

        vm.title = 'Nouveau mot de passe'
      }

      console.log('initModal', vm.upgradePassword)
      if (vm.upgradePassword) {
        vm.message = `Pour plus de sécurité, veuillez changer votre mot de passe.`
      }

      if (vm.$route.query.token || vm.upgradePassword) {
        vm.showInput.password = false

        setTimeout(() => {
          vm.$refs.passwordNew.focus()
        }, 100)
      } else {
        setTimeout(() => {
          vm.$refs.formAuth.$refs.password.focus()
        }, 100)
      }
    },
    show () {
      this.$refs.modalUpdatePassword.show()
    },
    hide () {
      const vm = this

      vm.$refs.modalUpdatePassword.hide()
    },
    hidden () {
      this.$router.replace('/')
    },
    handleOk (bvModalEvt) {
      const vm = this

      bvModalEvt.preventDefault()
      vm.handleSubmit()
    },
    handleSubmit () {
      const vm = this

      if (!vm.checkFormValidity) {
        return
      }

      vm.updatePassword()
    },
    updatePassword: function () {
      const vm = this

      vm.updatePasswordLoad = true
      window.$.ajax({
        method: 'PUT',
        url: `${process.env.API_AUTH}/labco/user-password`,
        data: {
          login: vm.value.login,
          correspondant: vm.value.correspondant,
          password: vm.value.password,
          passwordNew: vm.passwordNew
        }
      })
        .done(function () {
          let message = `Votre mot de passe à été mis à jour`
          if (vm.$route.query.token || vm.upgradePassword) {
            message = `Vous pouvez maintenant vous connectez avec votre nouveau mot de passe`
          }
          vm.upgradePassword = false
          vm.value.password = vm.passwordNew
          vm.hide()
          vm.$bvToast.toast(message, {
            title: 'Mise à jour de votre mot de passe',
            variant: 'success',
            solid: true
          })
        })
        .fail(function (xhr) {
          const errorMessage = window.fail(xhr)
          vm.$bvToast.toast(errorMessage, {
            title: 'Oups !',
            variant: 'warning',
            solid: true
          })
        })
        .always(function () {
          vm.updatePasswordLoad = false
        })
    }
  },
  computed: {
    checkFormValidity () {
      const vm = this
      let valid = false

      if (
        vm.passwordNewValide &&
        vm.passwordNewBisValide
      ) {
        valid = true
      }

      return valid
    },
    passwordNewValide: function () {
      const vm = this
      let state = null

      if (!vm.passwordNew || vm.passwordNew.length < 1) {
        return state
      }

      if (
        vm.checkConstrainteLen &&
        vm.checkConstrainteNumber &&
        vm.checkConstrainteMajuscule &&
        vm.checkConstrainteMinuscule &&
        vm.checkConstrainteSpecialChar
      ) {
        state = true
      } else {
        state = false
      }

      return state
    },
    passwordNewBisValide: function () {
      const vm = this
      let state = null

      if (vm.passwordNew && vm.passwordNewBis && vm.passwordNewValide) {
        if (vm.passwordNew === vm.passwordNewBis) {
          state = true
        } else {
          state = false
        }
      }

      return state
    },
    checkConstrainteLen: function () {
      const vm = this
      let state = null

      if (vm.passwordNew) {
        if (vm.passwordNew.length >= 8) {
          state = true
        } else {
          state = false
        }
      }

      return state
    },
    checkConstrainteNumber: function () {
      const vm = this
      let state = null

      if (vm.passwordNew) {
        if (/[0-9]/.exec(vm.passwordNew) === null) {
          state = false
        } else {
          state = true
        }
      }

      return state
    },
    checkConstrainteMajuscule: function () {
      const vm = this
      let state = null

      if (vm.passwordNew) {
        if (/[A-Z]/.exec(vm.passwordNew) === null) {
          state = false
        } else {
          state = true
        }
      }

      return state
    },
    checkConstrainteMinuscule: function () {
      const vm = this
      let state = null

      if (vm.passwordNew) {
        if (/[a-z]/.exec(vm.passwordNew) === null) {
          state = false
        } else {
          state = true
        }
      }

      return state
    },
    checkConstrainteSpecialChar: function () {
      const vm = this
      let state = null

      if (vm.passwordNew) {
        if (/[\W]/.exec(vm.passwordNew) === null) {
          state = false
        } else {
          state = true
        }
      }

      return state
    }
  },
  components: {
    FormAuth
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/Auth/ModalUpdatePassword.vue